// React and Library Imports
import { Navigate } from "react-router-dom";

// Auth Pages
import ForgotPassword from "pages/Authentication/ForgotPassword";
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/Logout";
import Register from "pages/Authentication/Register";
import UserProfile from "pages/Authentication/user-profile";

// Error Pages
import Fourzerofour from "pages/AuthenticationInner/Errors/404Error";
import Fivezerozero from "pages/AuthenticationInner/Errors/500Error";
import Fivezerothree from "pages/AuthenticationInner/Errors/503Error";
import OfflinePage from "pages/AuthenticationInner/Errors/Offline";

// Constants & Routes
import CombinedRoutes from "./CombinedRoutes";
import Dashboard from "pages/Dashboard";

const authProtectedRoutes = [
  // Dashboard
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  
  // User Profile
  { path: "/user-profile", component: <UserProfile /> },
  
  // Add any other modular routes
  ...CombinedRoutes,

  // Default Redirect
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/register", component: <Register /> },
  { path: "/forgot-password", component: <ForgotPassword /> },

  // Errors
  { path: "/auth-404", component: <Fourzerofour /> },
  { path: "/auth-500", component: <Fivezerozero /> },
  { path: "/auth-503", component: <Fivezerothree /> },
  { path: "/auth-offline", component: <OfflinePage /> },
];

export { authProtectedRoutes, publicRoutes };

